import React from 'react';
export default function ConnectRpiPage({ route, navigation }: any) {
    return (
        <>
        </>
    );
}
